import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../components/deprecated/DataTable/DataTable";

import { DataObjectField } from "to-be-removed/LocalData/General/DataObjectField/DataObjectField";
import { FirebaseDataDateField } from "to-be-removed/LocalData/General/DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "to-be-removed/LocalData/General/DataObjectField/Generic/FirebaseDataNumberField";
import { DataObjectHelper } from "../../General/DataObjects/DataObjectHelper";
import { LocalData } from "../../General/LocalData";
import { NotificationData } from "./NotificationData";

export class NotificationDataHelper extends DataObjectHelper<NotificationData> {
  id = () => "notifiation";

  sendDate = new FirebaseDataDateField<NotificationData>("sendDate", t("main.sendDate"), (notification) => notification.sendDate, "today");
  type = new FirebaseDataNumberField<NotificationData>("type", t("main.type"), (notification) => notification.type, "format_list_numbered");

  allFields(): DataObjectField<any, NotificationData>[] {
    return [this.sendDate, this.type];
  }
  displayName(): string {
    return t("main.notification");
  }
  override getAllDatas(): NotificationData[] {
    if (LocalData.currentUser.notifications !== undefined) {
      return LocalData.currentUser.notifications.documents;
    } else {
      return [];
    }
  }

  loadAll(): Promise<any> {
    const promise = new Promise<NotificationData[]>((resolve) => {
      LocalData.currentUser.notifications?.load((notifications) => {
        resolve(notifications);
      });
    });

    return promise;
  }

  getAllDataTableDatas(documents: NotificationData[]): DataTableData[] {
    return documents.map((notification) => {
      return {
        key: notification.id,
        cells: {
          sendDate: notification.sendDate,
          type: notification.type,
        },
      };
    });
  }

  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "sendDate",
        title: t("main.sendDate"),
      },
      {
        key: "type",
        title: t("main.type"),
      },
    ];
  }
}

